exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-description-text p {\n  margin-bottom: 10px; }\n\n.app-description-text ul {\n  margin-left: 2em;\n  margin-bottom: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js??ref--2-3!./src/components/AppDescription/AppDescription.scss
// module id = 2523
// module chunks = 0